"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _store = _interopRequireDefault(require("store/dist/store.modern"));
var LocalAuthStore = /*#__PURE__*/function () {
  function LocalAuthStore(clientId) {
    this.prefix = void 0;
    this.prefix = "auth." + clientId;
  }
  var _proto = LocalAuthStore.prototype;
  _proto.get = function get(key) {
    return _store.default.get(this.prefix + "." + key);
  };
  _proto.set = function set(key, value) {
    _store.default.set(this.prefix + "." + key, value);
  };
  _proto.delete = function _delete(key) {
    _store.default.remove(this.prefix + "." + key);
  };
  _proto.clear = function clear() {
    var _this = this;
    _store.default.each(function (val, key) {
      if (key.startsWith(_this.prefix)) {
        _store.default.remove(key);
      }
    });
  };
  return LocalAuthStore;
}();
var _default = exports.default = LocalAuthStore;